import React from 'react';
import { useRecoilState } from 'recoil';
import { counterState } from './recoil/counterAtom';

function App() {
  const [count, setCount] = useRecoilState(counterState);

  const increment = () => setCount(prev => prev + 1);
  const decrement = () => setCount(prev => prev - 1);
  const reset = () => setCount(0);

  return (
    <div style={{ textAlign: 'center', marginTop: '4rem' }}>
      <h1>Recoil Counter (Persisted)</h1>
      <h2>{count}</h2>
      <button onClick={increment}>➕ Increment</button>
      <button onClick={decrement} style={{ marginLeft: '1rem' }}>➖ Decrement</button>
      <button onClick={reset} style={{ marginLeft: '1rem' }}>🔄 Reset</button>
    </div>
  );
}

export default App;

